import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    durationContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: 210
    },
    progressPercentage: {
        fontWeight: 400,
        fontSize: 12,
        color: theme.palette.label.main
    },
    progress: {
        width: '100%',
        marginRight: theme.spacing(2),
        height: 8,
        borderRadius: 20,
        backgroundColor: theme.palette.body[400]
    }
}));

export default useStyles;
